export default __webpack_public_path__ + "static/media/acms-okr.8161869f.svg";